import React from 'react';

/**
 * Branded full-page loading indicator shown while a page's data is being
 * fetched from Supabase for the first time. Once a store is cached, pages
 * render instantly and this never appears again — so it only shows on a
 * genuine cold load, never with half-empty data.
 */
export default function PageLoader({ label = 'Loading…', sublabel }) {
  return (
    <div className="page-loader" role="status" aria-live="polite">
      <div className="page-loader-mark">
        <span className="page-loader-ring" />
        <span className="page-loader-logo">NO</span>
      </div>
      <div className="page-loader-text">
        <div className="page-loader-label">{label}</div>
        {sublabel && <div className="page-loader-sublabel">{sublabel}</div>}
      </div>
    </div>
  );
}
